import client from "../../client";
import clientAuth from "../../clientAuth";
export default {
  getClientSecret: () => clientAuth.get(`stripe/setup-intent`),
  index: (page = 1) => clientAuth.get(`stripe/cards?page=${page}`),
  destroy: (userData) =>
    clientAuth.post(`stripe/cards/delete`, { json: userData }),
  detDefaultCard: (cardData) =>
    clientAuth.post(`stripe/cards/default`, { json: cardData }),
};
